import { useThemeSwitch } from 'hooks/theme'
import { useTheme } from 'styled-components'

export const UsageSummaryIcon = () => {
  const theme = useTheme()
  const { mode } = useThemeSwitch()

  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M11.9997 13.3346H3.99967C2.52692 13.3346 1.33301 12.1407 1.33301 10.668V9.33464C1.33301 5.65274 4.31778 2.66797 7.99967 2.66797C11.6816 2.66797 14.6663 5.65274 14.6663 9.33464V10.668C14.6663 12.1407 13.4724 13.3346 11.9997 13.3346Z"
        fill={theme.colors.accent1}
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M7.99963 5.16797C6.37293 5.16797 5.42778 5.96602 4.79776 6.93961C4.64774 7.17145 4.33818 7.23777 4.10635 7.08774C3.87451 6.93772 3.80819 6.62816 3.95821 6.39633C4.72285 5.21472 5.95146 4.16797 7.99963 4.16797C10.0478 4.16797 11.2764 5.21472 12.0411 6.39633C12.1911 6.62816 12.1248 6.93772 11.8929 7.08774C11.6611 7.23777 11.3515 7.17145 11.2015 6.93961C10.5715 5.96602 9.62634 5.16797 7.99963 5.16797Z"
        fill={theme.colors.bgPrimary}
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M10.4473 8.22567C10.5708 7.97868 10.4707 7.67834 10.2237 7.55485C9.97673 7.43135 9.67639 7.53147 9.5529 7.77846L7.76781 11.3486C6.77263 11.4637 6 12.3093 6 13.3353H10C10 12.5181 9.50991 11.8154 8.80763 11.5051L10.4473 8.22567Z"
        fill={theme.colors.bgPrimary}
      />
    </svg>
  )
}
